import { render, staticRenderFns } from "./BoardingFilter.vue?vue&type=template&id=32c256de&"
import script from "./BoardingFilter.vue?vue&type=script&lang=js&"
export * from "./BoardingFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports